<template>
	<div class="d-flex flex-column" id="MainContainer">

		<div class="dialog-header">
			<v-toolbar class="bg-white">
				<div class="row">
					<div class="col-7">
					<div class="flex-container" style="display: flex;align-items: center;">
						<h1 class="mb-0" style="white-space: nowrap;">{{$t('res_Label_VisualTracking')}}</h1> 
 						<div class="input-group ml-4 mr-4 border shadow-sm rounded"> 
							 <v-text-field class="search-field" v-model="searchValue" solo :label="$t('res_Label_SearchPlaceHolder')" prepend-icon="mdi-magnify" @input="filterChart(false,0)"> 
                            </v-text-field>
                            <v-btn v-if="searchValue.length" @click="searchValue = '';filterChart();" color="white" class="p-0 close-btn" bottom >
                                <img src="/assets/images/icons/close.svg" alt="search" />
                            </v-btn>
						</div>  
					</div>
				</div>
				</div>
				<div v-show="ShowChart" class="search-buttons-space">
					<div class="d-flex TrackerBtn" style="gap: 12px">
						<span class="border ml-1 mr-1 p-2 rounded shadow-sm" style="width: 160px;display: flex;justify-content: space-between;">
							<v-btn @click="fitChart()" style="min-width: unset !important" icon> 
								<i  class="fa fa-align-center IconFit"></i>
								</v-btn> 
							<v-btn @click="zoomOut()" style="min-width: unset !important;" icon><v-icon class="custom-icon primary-hover">mdi-minus-ring</v-icon></v-btn>
							<v-btn @click="zoomIn()" style="min-width: unset !important" icon><v-icon class="custom-icon primary-hover">mdi-plus-ring</v-icon></v-btn>
							<v-btn @click="swap('horizontal')" style=";min-width: unset !important" icon><i id="horizontalIcon"  class="fa fa-arrows-alt-h text-primary" style="font-size:17px"></i></v-btn>
							<v-btn id="swapTopBtn" @click="swap('top')" style="min-width: unset !important" icon><i id="topIcon"  class="fa fa-arrows-alt-v text-primary custom-icon-Active" style="font-size:17px"></i></v-btn>
						</span> 
						<v-btn @click="closeDialog()" style="min-width: unset !important;" icon><v-icon class="custom-icon primary-hover">mdi-close</v-icon></v-btn> 
					</div> 
				</div>  
			</v-toolbar> 
		</div> 

        <div v-show="!ShowChart" id="skilitonsDiv"  class="dialog-body p-4"> 
			<div class="row" v-for="index in 6" :key="index"> 
				<div class="col-3 p-3">
					<v-skeleton-loader :elevation="7"  color="secondary" type="article"></v-skeleton-loader>
				</div>
				<div class="col-3 p-3">
					<v-skeleton-loader :elevation="7"  color="secondary" type="article"></v-skeleton-loader>
				</div> 
				<div class="col-3 p-3">
					<v-skeleton-loader :elevation="7"  color="secondary" type="article"></v-skeleton-loader>
				</div>
				<div class="col-3 p-3">
					<v-skeleton-loader :elevation="7"  color="secondary" type="article"></v-skeleton-loader>
				</div> 
			</div>  
		</div> 
		 
		<div v-show="ShowChart" id="ChartContent"  class="dialog-body">
			<div style="width: 100%"> 
				<div id="ChartContentTemplates"  style="display: none"> 
					<div id="root-card-template" class="">
						<div class="card_track">
							<v-card class="template_card"> 
								<h3 class="dark-text-tracking" style="margin: 0px;">_SenderEntity_</h3> 
								<p class="gray-text-tracking">_RegisteredByUser_</p> 
								<p class="gray-text-tracking">{{$t('res_MenuItems_ReferenceNumber')}}: _ReferenceNumber_</p>
							</v-card>
						</div>
					</div>
 
					<div id="card-template" class="">
 						<div class="card_track"> 
							<v-card class="template_card container"> 
								<div class="card-icons_main row" style="float: right;">
									<div class="body-right-icons"> 
										<v-btn  data-TargetId="InProgressIcon" class="min-width-icons CardIconBtn InProgressIconClass hiddenClass" id="isInProgress_TransferId_"  width="fit-content!important" height="fit-content" icon>
											<div class="icon tracker-tooltip">
												<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" />
													<mask id="path-1-outside-1_139_5427" maskUnits="userSpaceOnUse" x="1" y="1" width="22" height="22" fill="black">
														<rect fill="#205CDF" x="1" y="1" width="12" height="22" />
														<path d="M12 2C14.3136 2 16.5555 2.80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09717 21.5694C6.88323 20.8978 4.97066 19.4793 3.68532 17.5557C2.39998 15.6321 1.8214 13.3222 2.04817 11.0198C2.27494 8.71741 3.29302 6.56486 4.92895 4.92893L7.75738 7.75736C6.77582 8.73891 6.16497 10.0304 6.02891 11.4119C5.89285 12.7933 6.23999 14.1792 7.0112 15.3334C7.7824 16.4876 8.92995 17.3387 10.2583 17.7416C11.5867 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z" />
													</mask>
													<path d="M12 2C14.3136 2 16.5555 2. 80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09717 21.5694C6.88323 20.8978 4.97066 19.4793 3.68532 17.5557C2.39998 15.6321 1.8214 13.3222 2.04817 11.0198C2.27494 8.71741 3.29302 6.56486 4.92895 4.92893L7.75738 7.75736C6.77582 8.73891 6.16497 10.0304 6.02891 11.4119C5.89285 12.7933 6.23999 14.1792 7.0112 15.3334C7.7824 16.4876 8.92995 17.3387 10.2583 17.7416C11.5867 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z" fill="#205CDF" />
													<path d="M12 2V1H11V2L12 2ZM18.3439 4.2699L18.9783 3.49689L18.3439 4.2699ZM20.8192 16.714L21.7011 17.1854L20.8192 16.714ZM15.8268 21.2388L16.2095 22.1627L15.8268 21.2388ZM9.09717 21.5694L8.80688 22.5263L9.09717 21.5694ZM3.68532 17.5557L2.85385 18.1113L3.68532 17.5557ZM2.04817 11.0198L1.05298 10.9218L2.04817 11.0198ZM4.92895 4.92893L5.63606 4.22182L4.92895 3.51472L4.22184 4.22182L4.92895 4.92893ZM7.75738 7.75736L8.46448 8.46446L9.17159 7.75736L8.46448 7.05025L7.75738 7.75736ZM6.02891 11.4119L5.03372 11.3139L6.02891 11.4119ZM7.0112 15.3334L6.17973 15.889L7.0112 15.3334ZM10.2583 17.7416L9.96802 18.6986L10.2583 17.7416ZM14.2961 17.5433L13.9134 16.6194L14.2961 17.5433ZM17.2915 14.8284L16.4096 14.357L17.2915 14.8284ZM17.8847 10.8295L16.9039 11.0245L17.8847 10.8295ZM15.8064 7.36194L16.4408 6.58893L15.8064 7.36194ZM12 6H11V7H12V6ZM12 3C14.0822 3 16.1 3.72197 17.7096 5.04291L18.9783 3.49689C17.0111 1.88241 14.5449 1 12 1V3ZM17.7096 5.04291C19.3191 6.36384 20.4209 8.202 20.8271 10.2442L22.7887 9.85401C22.2922 7.358 20.9456 5.11136 18.9783 3.49689L17.7096 5.04291ZM20.8271 10.2442C21.2333 12.2864 20.9188 14.4062 19.9373 16.2426L21.7011 17.1854C22.9008 14.941 23.2851 12.35 22.7887 9.85401L20.8271 10.2442ZM19.9373 16.2426C18.9558 18.0789 17.3679 19.5181 15.4442 20.3149L16.2095 22.1627C18.5607 21.1888 20.5015 19.4298 21.7011 17.1854L19.9373 16.2426ZM15.4442 20.3149C13.5205 21.1117 11.38 21.2169 9.38745 20.6125L8.80688 22.5263C11.2422 23.2651 13.8583 23.1366 16.2095 22.1627L15.4442 20.3149ZM9.38745 20.6125C7.39491 20.008 5.67359 18.7314 4.51679 17.0001L2.85385 18.1113C4.26772 20.2273 6.37156 21.7876 8.80688 22.5263L9.38745 20.6125ZM4.51679 17.0001C3.35998 15.2688 2.83926 13.19 3.04335 11.1178L1.05298 10.9218C0.803539 13.4545 1.43997 15.9953 2.85385 18.1113L4.51679 17.0001ZM3.04335 11.1178C3.24745 9.04567 4.16372 7.10837 5.63606 5.63604L4.22184 4.22182C2.42232 6.02134 1.30243 8.38915 1.05298 10.9218L3.04335 11.1178ZM4.22184 5.63604L7.05027 8.46446L8.46448 7.05025L5.63606 4.22182L4.22184 5.63604ZM7.05027 7.05025C5.90512 8.1954 5.19246 9.70219 5.03372 11.3139L7.02409 11.5099C7.13748 10.3587 7.64652 9.28243 8.46448 8.46446L7.05027 7.05025ZM5.03372 11.3139C4.87498 12.9256 5.27999 14.5424 6.17973 15.889L7.84267 14.7779C7.2 13.816 6.91071 12.6611 7.02409 11.5099L5.03372 11.3139ZM6.17973 15.889C7.07947 17.2355 8.41827 18.2285 9.96802 18.6986L10.5486 16.7847C9.44163 16.4489 8.48534 15.7397 7.84267 14.7779L6.17973 15.889ZM9.96802 18.6986C11.5178 19.1687 13.1826 19.0869 14.6788 18.4672L13.9134 16.6194C12.8447 17.0621 11.6556 17.1205 10.5486 16.7847L9.96802 18.6986ZM14.6788 18.4672C16.175 17.8474 17.41 16.728 18.1735 15.2998L16.4096 14.357C15.8643 15.3772 14.9822 16.1767 13.9134 16.6194L14.6788 18.4672ZM18.1735 15.2998C18.9369 13.8715 19.1815 12.2227 18.8655 10.6344L16.9039 11.0245C17.1296 12.1591 16.9549 13.3368 16.4096 14.357L18.1735 15.2998ZM18.8655 10.6344C18.5496 9.046 17.6926 7.61632 16.4408 6.58893L15.172 8.13495C16.0662 8.8688 16.6783 9.89 16.9039 11.0245L18.8655 10.6344ZM16.4408 6.58893C15.1889 5.56154 13.6195 5 12 5L12 7C13.1568 7 14.2778 7.4011 15.172 8.13495L16.4408 6.58893ZM13 6L13 2L11 2L11 6H13Z" fill="#205CDF" mask="url(#path-1-outside-1_139_5427)" />
													<path d="M12 12L5 5" stroke="#205CDF" stroke-width="2" stroke-linecap="round" />
												</svg>
												 <span  class="tracker-tooltiptext">{{$t('res_Label_InProgress')}}</span> 
											</div> 
										</v-btn>

										<v-btn data-TargetId="CompletedIcon" id="isCompleted_TransferId_"  width="fit-content!important" class="min-width-icons CardIconBtn CompletedIconClass hiddenClass" height="fit-content" icon>
											<div class="icon tracker-tooltip">
												<svg class="iconSVG" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 6.96023C9.21672 6.96023 6.96023 9.21672 6.96023 12.0002C6.96023 14.7837 9.21672 17.0402 12.0002 17.0402C14.7837 17.0402 17.0402 14.7837 17.0402 12.0002C17.0402 9.21672 14.7837 6.96023 12.0002 6.96023ZM6.24023 12.0002C6.24023 8.81907 8.81907 6.24023 12.0002 6.24023C15.1814 6.24023 17.7602 8.81907 17.7602 12.0002C17.7602 15.1814 15.1814 17.7602 12.0002 17.7602C8.81907 17.7602 6.24023 15.1814 6.24023 12.0002Z" fill="#205CDF" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.2318 8.85984C15.5853 8.43556 16.2159 8.37824 16.6402 8.7318C17.0644 9.08537 17.1218 9.71593 16.7682 10.1402L13.1702 14.4578L13.1333 14.5021L13.1333 14.5021C12.8377 14.857 12.5533 15.1983 12.2823 15.4448C11.9787 15.721 11.5728 15.9916 11.0234 16.0166C10.474 16.0415 10.0453 15.8087 9.71791 15.5612C9.42567 15.3402 9.11158 15.026 8.78509 14.6994L8.78507 14.6993L8.74426 14.6585L7.29287 13.2071C6.90234 12.8166 6.90234 12.1834 7.29287 11.7929C7.68339 11.4024 8.31656 11.4024 8.70708 11.7929L10.1585 13.2443C10.5414 13.6273 10.7564 13.839 10.9242 13.9659L10.9306 13.9707L10.9366 13.9653C11.0922 13.8238 11.2871 13.5934 11.6338 13.1774L15.2318 8.85984Z" fill="#205CDF" />
												</svg>  
												<span class="tracker-tooltiptext">{{$t('res_Label_Done')}}</span>
											</div>
										</v-btn> 

										<v-btn data-TargetId="OverdueIcon" id="isOverdue_TransferId_"  width="fit-content!important" class="min-width-icons CardIconBtn OverdueIconClass hiddenClass" height="fit-content" icon>
											<div class="icon tracker-tooltip">
												<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M17.4003 11.9996C17.4003 14.9819 14.9827 17.3996 12.0003 17.3996C9.018 17.3996 6.60034 14.9819 6.60034 11.9996C6.60034 9.01727 9.018 6.59961 12.0003 6.59961C14.9827 6.59961 17.4003 9.01727 17.4003 11.9996ZM12.0003 16.7996C14.6513 16.7996 16.8003 14.6506 16.8003 11.9996C16.8003 9.34864 14.6513 7.19961 12.0003 7.19961C9.34938 7.19961 7.20034 9.34864 7.20034 11.9996C7.20034 14.6506 9.34938 16.7996 12.0003 16.7996Z" fill="#205CDF" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 6.5C13 5.94772 12.5523 5.5 12 5.5C11.4477 5.5 11 5.94772 11 6.5V11.75C11 12.4404 11.5596 13 12.25 13H15.5C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11H13V6.5Z" fill="#205CDF" />
												</svg> 
											    <span  class="tracker-tooltiptext">{{$t('res_Label_Overdue')}}</span>
											</div>
										</v-btn>

										<v-btn data-TargetId="CCedIcon" id="isCC_TransferId_"  width="fit-content!important" class="min-width-icons CardIconBtn  CCedIconClass hiddenClass" height="fit-content" icon>
											<div class="icon"><span style="color:#5583E5">cc</span>
											</div>
										</v-btn> 

										  <v-btn data-TargetId="ReadIcon" id="isRead_TransferId_"  width="fit-content!important" class="min-width-icons CardIconBtn ReadIconClass hiddenClass" height="fit-content" icon>
											<div class="icon tracker-tooltip">
												<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" /> 
													<path fill-rule="evenodd" clip-rule="evenodd" d="M3.00034 10.4147C3 10.569 3 10.7304 3 10.8992V15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15V10.8992C21 10.7304 21 10.569 20.9997 10.4147L19.2929 12.1215C18.7303 12.6841 17.9672 13.0002 17.1716 13.0002H6.82843C6.03278 13.0002 5.26972 12.6841 4.70711 12.1215L3.00034 10.4147ZM3.23713 7.82307L6.12132 10.7073C6.30886 10.8948 6.56321 11.0002 6.82843 11.0002H17.1716C17.4368 11.0002 17.6911 10.8948 17.8787 10.7073L20.7629 7.82307C20.6991 7.63992 20.6182 7.47289 20.5155 7.31487C20.031 6.56931 19.1662 6.18499 17.4368 5.41637L17.4368 5.41636L13.6246 3.72202C12.8245 3.36643 12.4244 3.18863 12 3.18863C11.5756 3.18863 11.1755 3.36643 10.3754 3.72202L6.56317 5.41636C4.83375 6.18499 3.96905 6.56931 3.48452 7.31487C3.38183 7.47289 3.30091 7.63992 3.23713 7.82307Z" fill="#205CDF" />
												</svg>
												<span class="tracker-tooltiptext">{{$t('res_Label_Read')}}</span>
											</div>
										</v-btn>  
 

										<v-btn  data-TargetId="UnreadIcon" id="isUnRead_TransferId_"  class="min-width-icons CardIconBtn UnreadIconClass hiddenClass" height="fit-content" width="auto!important" icon>
											<div class="icon tracker-tooltip">
												<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M3.0132 9.15129C3 9.69022 3 10.3021 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 10.3021 21 9.69022 20.9868 9.15129L12.9713 13.6044C12.3672 13.9399 11.6328 13.9399 11.0287 13.6044L3.0132 9.15129ZM3.24297 7.02971C3.32584 7.05052 3.4074 7.08237 3.48564 7.12584L12 11.856L20.5144 7.12584C20.5926 7.08237 20.6742 7.05052 20.757 7.02971C20.6271 6.55619 20.4276 6.18491 20.1213 5.87868C19.2426 5 17.8284 5 15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3.57245 6.18491 3.37294 6.55619 3.24297 7.02971Z" fill="#205CDF" />
												</svg> 
												  <span class="tracker-tooltiptext">{{$t('res_Label_Unread')}}</span>
											</div>
										</v-btn>

 
										<v-btn  data-TargetId="SignedIcon" id="isSigned_TransferId_"  class="min-width-icons CardIconBtn SignedIconClass hiddenClass" height="fit-content" width="auto!important" icon>
											<div class="icon tracker-tooltip">  
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<!-- <title>file-sign</title> -->
												<path d="M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" fill="#205CDF"  />
												</svg>
												<span   class="tracker-tooltiptext">{{$t('res_Label_Signed')}}</span>
											</div>
										</v-btn>
										

										<v-btn  data-TargetId="CompletedWithDelayIcon" id="isCompletedWithDelay_TransferId_"  class="min-width-icons CardIconBtn CompletedWithDelayIconClass hiddenClass" height="fit-content" width="auto!important" icon>
											<div class="icon tracker-tooltip">  
												<svg class="iconSVG" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect width="40" height="40" rx="4" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 6.96023C9.21672 6.96023 6.96023 9.21672 6.96023 12.0002C6.96023 14.7837 9.21672 17.0402 12.0002 17.0402C14.7837 17.0402 17.0402 14.7837 17.0402 12.0002C17.0402 9.21672 14.7837 6.96023 12.0002 6.96023ZM6.24023 12.0002C6.24023 8.81907 8.81907 6.24023 12.0002 6.24023C15.1814 6.24023 17.7602 8.81907 17.7602 12.0002C17.7602 15.1814 15.1814 17.7602 12.0002 17.7602C8.81907 17.7602 6.24023 15.1814 6.24023 12.0002Z" fill="#205CDF" />
													<path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.2318 8.85984C15.5853 8.43556 16.2159 8.37824 16.6402 8.7318C17.0644 9.08537 17.1218 9.71593 16.7682 10.1402L13.1702 14.4578L13.1333 14.5021L13.1333 14.5021C12.8377 14.857 12.5533 15.1983 12.2823 15.4448C11.9787 15.721 11.5728 15.9916 11.0234 16.0166C10.474 16.0415 10.0453 15.8087 9.71791 15.5612C9.42567 15.3402 9.11158 15.026 8.78509 14.6994L8.78507 14.6993L8.74426 14.6585L7.29287 13.2071C6.90234 12.8166 6.90234 12.1834 7.29287 11.7929C7.68339 11.4024 8.31656 11.4024 8.70708 11.7929L10.1585 13.2443C10.5414 13.6273 10.7564 13.839 10.9242 13.9659L10.9306 13.9707L10.9366 13.9653C11.0922 13.8238 11.2871 13.5934 11.6338 13.1774L15.2318 8.85984Z" fill="Red" />
												</svg> 
												<span   class="tracker-tooltiptext">{{$t('res_Label_CompletedWithDelay')}}</span>
											</div>
										</v-btn>


										<v-btn  data-TargetId="RecallIcon" id="isRecall_TransferId_"  class="min-width-icons CardIconBtn RecallIconClass hiddenClass" height="fit-content" width="auto!important" icon>
											<div class="icon tracker-tooltip">  
												<!-- <title>restart</title> -->
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
												<path d="M12,4C14.1,4 16.1,4.8 17.6,6.3C20.7,9.4 20.7,14.5 17.6,17.6C15.8,19.5 13.3,20.2 10.9,19.9L11.4,17.9C13.1,18.1 14.9,17.5 16.2,16.2C18.5,13.9 18.5,10.1 16.2,7.7C15.1,6.6 13.5,6 12,6V10.6L7,5.6L12,0.6V4M6.3,17.6C3.7,15 3.3,11 5.1,7.9L6.6,9.4C5.5,11.6 5.9,14.4 7.8,16.2C8.3,16.7 8.9,17.1 9.6,17.4L9,19.4C8,19 7.1,18.4 6.3,17.6Z" fill="#205CDF" />
												</svg>
												<span   class="tracker-tooltiptext">{{$t('res_MenuItems_Recall')}}</span>
											</div>
										</v-btn> 
									</div>
								</div>
                                <div class="body-left-icons row" style="float: left;position: absolute;">
									<h3 class="ToStructure-text-tracking" style="margin: 0px;">_TransferToStructureName_</h3>
								    <p class="toUser-text-tracking">_TransferToUser_</p>
                                    <p class="gray-text-tracking">_PurposeName_</p>
									<p class="date-text-tracking">{{$t('res_Label_TransferDate')}} :<span style="padding-left: 20px;">_TransferDate_</span></p>
									<p class="date-text-tracking">{{$t('res_Label_OpenDate')}} :<span style="padding-left: 35px;">_TransferOpenedDate_</span></p> 
								</div>
							</v-card>
						</div>
					</div>
				</div> 
			  
				<div id="ChartContainer" ref="svgElementContainer">
				</div>   
			</div>
		</div> 

		<div class="dialog-footer">

					<div class="tracking-footer">
						<v-btn width="auto!important" class=" instructionItem" icon>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="4" fill="#F77600" /></svg>  &nbsp;
							{{$t('res_Label_SendToUser')}}
						</v-btn> 

						<v-btn width="auto!important" class=" instructionItem" icon>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="4" fill="#F77600" /></svg>  &nbsp;
							{{$t('res_Label_SendToUser')}}
						</v-btn>  

						<v-btn width="auto!important" class=" instructionItem" icon>
							<svg width="24" height="24" viewBox="0 0 24 24" style="" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="4" fill="#1186FA" /> </svg> &nbsp;
							{{$t('res_Label_SendToStructure')}}
						</v-btn> 

						<v-btn width="auto!important" id="InProgressIcon" class=" instructionItem" icon @click="filterChart(true, TransferStatuses.InProgress)">
							<div class="icon"><svg width="24" height="24" viewBox="0 0 24 24" style="" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" />
									<mask id="path-1-outside-1_139_5427" maskUnits="userSpaceOnUse" x="1" y="1" width="18" height="18" fill="black">
										<rect fill="#205CDF" x="1" y="1" width="18" height="18" />
										<path d="M12 2C14.3136 2 16.5555 2.80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09717 21.5694C6.88323 20.8978 4.97066 19.4793 3.68532 17.5557C2.39998 15.6321 1.8214 13.3222 2.04817 11.0198C2.27494 8.71741 3.29302 6.56486 4.92895 4.92893L7.75738 7.75736C6.77582 8.73891 6.16497 10.0304 6.02891 11.4119C5.89285 12.7933 6.23999 14.1792 7.0112 15.3334C7.7824 16.4876 8.92995 17.3387 10.2583 17.7416C11.5867 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z" />
									</mask>
									<path d="M12 2C14.3136 2 16.5555 2.80219 18.3439 4.2699C20.1323 5.7376 21.3565 7.78 21.8079 10.0491C22.2592 12.3182 21.9098 14.6736 20.8192 16.714C19.7286 18.7543 17.9643 20.3534 15.8268 21.2388C13.6894 22.1242 11.3111 22.241 9.09717 21.5694C6.88323 20.8978 4.97066 19.4793 3.68532 17.5557C2.39998 15.6321 1.8214 13.3222 2.04817 11.0198C2.27494 8.71741 3.29302 6.56486 4.92895 4.92893L7.75738 7.75736C6.77582 8.73891 6.16497 10.0304 6.02891 11.4119C5.89285 12.7933 6.23999 14.1792 7.0112 15.3334C7.7824 16.4876 8.92995 17.3387 10.2583 17.7416C11.5867 18.1446 13.0136 18.0745 14.2961 17.5433C15.5786 17.0121 16.6372 16.0526 17.2915 14.8284C17.9459 13.6042 18.1555 12.1909 17.8847 10.8295C17.6139 9.468 16.8794 8.24256 15.8064 7.36194C14.7333 6.48132 13.3881 6 12 6L12 2Z" fill="#205CDF" />
									<path d="M12 2V1H11V2L12 2ZM18.3439 4.2699L18.9783 3.49689L18.3439 4.2699ZM20.8192 16.714L21.7011 17.1854L20.8192 16.714ZM15.8268 21.2388L16.2095 22.1627L15.8268 21.2388ZM9.09717 21.5694L8.80688 22.5263L9.09717 21.5694ZM3.68532 17.5557L2.85385 18.1113L3.68532 17.5557ZM2.04817 11.0198L1.05298 10.9218L2.04817 11.0198ZM4.92895 4.92893L5.63606 4.22182L4.92895 3.51472L4.22184 4.22182L4.92895 4.92893ZM7.75738 7.75736L8.46448 8.46446L9.17159 7.75736L8.46448 7.05025L7.75738 7.75736ZM6.02891 11.4119L5.03372 11.3139L6.02891 11.4119ZM7.0112 15.3334L6.17973 15.889L7.0112 15.3334ZM10.2583 17.7416L9.96802 18.6986L10.2583 17.7416ZM14.2961 17.5433L13.9134 16.6194L14.2961 17.5433ZM17.2915 14.8284L16.4096 14.357L17.2915 14.8284ZM17.8847 10.8295L16.9039 11.0245L17.8847 10.8295ZM15.8064 7.36194L16.4408 6.58893L15.8064 7.36194ZM12 6H11V7H12V6ZM12 3C14.0822 3 16.1 3.72197 17.7096 5.04291L18.9783 3.49689C17.0111 1.88241 14.5449 1 12 1V3ZM17.7096 5.04291C19.3191 6.36384 20.4209 8.202 20.8271 10.2442L22.7887 9.85401C22.2922 7.358 20.9456 5.11136 18.9783 3.49689L17.7096 5.04291ZM20.8271 10.2442C21.2333 12.2864 20.9188 14.4062 19.9373 16.2426L21.7011 17.1854C22.9008 14.941 23.2851 12.35 22.7887 9.85401L20.8271 10.2442ZM19.9373 16.2426C18.9558 18.0789 17.3679 19.5181 15.4442 20.3149L16.2095 22.1627C18.5607 21.1888 20.5015 19.4298 21.7011 17.1854L19.9373 16.2426ZM15.4442 20.3149C13.5205 21.1117 11.38 21.2169 9.38745 20.6125L8.80688 22.5263C11.2422 23.2651 13.8583 23.1366 16.2095 22.1627L15.4442 20.3149ZM9.38745 20.6125C7.39491 20.008 5.67359 18.7314 4.51679 17.0001L2.85385 18.1113C4.26772 20.2273 6.37156 21.7876 8.80688 22.5263L9.38745 20.6125ZM4.51679 17.0001C3.35998 15.2688 2.83926 13.19 3.04335 11.1178L1.05298 10.9218C0.803539 13.4545 1.43997 15.9953 2.85385 18.1113L4.51679 17.0001ZM3.04335 11.1178C3.24745 9.04567 4.16372 7.10837 5.63606 5.63604L4.22184 4.22182C2.42232 6.02134 1.30243 8.38915 1.05298 10.9218L3.04335 11.1178ZM4.22184 5.63604L7.05027 8.46446L8.46448 7.05025L5.63606 4.22182L4.22184 5.63604ZM7.05027 7.05025C5.90512 8.1954 5.19246 9.70219 5.03372 11.3139L7.02409 11.5099C7.13748 10.3587 7.64652 9.28243 8.46448 8.46446L7.05027 7.05025ZM5.03372 11.3139C4.87498 12.9256 5.27999 14.5424 6.17973 15.889L7.84267 14.7779C7.2 13.816 6.91071 12.6611 7.02409 11.5099L5.03372 11.3139ZM6.17973 15.889C7.07947 17.2355 8.41827 18.2285 9.96802 18.6986L10.5486 16.7847C9.44163 16.4489 8.48534 15.7397 7.84267 14.7779L6.17973 15.889ZM9.96802 18.6986C11.5178 19.1687 13.1826 19.0869 14.6788 18.4672L13.9134 16.6194C12.8447 17.0621 11.6556 17.1205 10.5486 16.7847L9.96802 18.6986ZM14.6788 18.4672C16.175 17.8474 17.41 16.728 18.1735 15.2998L16.4096 14.357C15.8643 15.3772 14.9822 16.1767 13.9134 16.6194L14.6788 18.4672ZM18.1735 15.2998C18.9369 13.8715 19.1815 12.2227 18.8655 10.6344L16.9039 11.0245C17.1296 12.1591 16.9549 13.3368 16.4096 14.357L18.1735 15.2998ZM18.8655 10.6344C18.5496 9.046 17.6926 7.61632 16.4408 6.58893L15.172 8.13495C16.0662 8.8688 16.6783 9.89 16.9039 11.0245L18.8655 10.6344ZM16.4408 6.58893C15.1889 5.56154 13.6195 5 12 5L12 7C13.1568 7 14.2778 7.4011 15.172 8.13495L16.4408 6.58893ZM13 6L13 2L11 2L11 6H13Z" fill="#205CDF" mask="url(#path-1-outside-1_139_5427)" />
									<path d="M12 12L5 5" stroke="#205CDF" stroke-width="2" stroke-linecap="round" />
								</svg>
							</div>
							{{$t('res_Label_InProgress')}}
						</v-btn>

						<v-btn width="auto!important" id="CompletedIcon" class=" instructionItem" icon  @click="filterChart(true, TransferStatuses.Completed)">
							<div class="icon"><svg width="24" style="" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" />

									<path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.2318 8.85984C15.5853 8.43556 16.2159 8.37824 16.6402 8.7318C17.0644 9.08537 17.1218 9.71593 16.7682 10.1402L13.1702 14.4578L13.1333 14.5021L13.1333 14.5021C12.8377 14.857 12.5533 15.1983 12.2823 15.4448C11.9787 15.721 11.5728 15.9916 11.0234 16.0166C10.474 16.0415 10.0453 15.8087 9.71791 15.5612C9.42567 15.3402 9.11158 15.026 8.78509 14.6994L8.78507 14.6993L8.74426 14.6585L7.29287 13.2071C6.90234 12.8166 6.90234 12.1834 7.29287 11.7929C7.68339 11.4024 8.31656 11.4024 8.70708 11.7929L10.1585 13.2443C10.5414 13.6273 10.7564 13.839 10.9242 13.9659L10.9306 13.9707L10.9366 13.9653C11.0922 13.8238 11.2871 13.5934 11.6338 13.1774L15.2318 8.85984Z" fill="#205CDF" />
								</svg></div> 
							{{$t('res_Label_Done')}}
						</v-btn>

						<v-btn id="OverdueIcon" width="auto!important" class=" instructionItem" icon @click="filterChart(true, TransferStatuses.Overdue)">
							<div class="icon"><svg style="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M17.4003 11.9996C17.4003 14.9819 14.9827 17.3996 12.0003 17.3996C9.018 17.3996 6.60034 14.9819 6.60034 11.9996C6.60034 9.01727 9.018 6.59961 12.0003 6.59961C14.9827 6.59961 17.4003 9.01727 17.4003 11.9996ZM12.0003 16.7996C14.6513 16.7996 16.8003 14.6506 16.8003 11.9996C16.8003 9.34864 14.6513 7.19961 12.0003 7.19961C9.34938 7.19961 7.20034 9.34864 7.20034 11.9996C7.20034 14.6506 9.34938 16.7996 12.0003 16.7996Z" fill="#205CDF" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM13 6.5C13 5.94772 12.5523 5.5 12 5.5C11.4477 5.5 11 5.94772 11 6.5V11.75C11 12.4404 11.5596 13 12.25 13H15.5C16.0523 13 16.5 12.5523 16.5 12C16.5 11.4477 16.0523 11 15.5 11H13V6.5Z" fill="#205CDF" />
								</svg>
							</div> 
							{{$t('res_Label_Overdue')}}
						</v-btn>

						<v-btn id="CCedIcon" width="auto!important" class=" instructionItem" icon @click="filterChart(true, TransferStatuses.CCed)">
							<div class="icon"><span style="color:#5583E5 !important">cc</span></div>&nbsp; 
							{{$t('res_Label_CC')}}
						</v-btn>

						<v-btn id="ReadIcon" width="auto!important" class=" instructionItem" icon  @click="filterChart(true, TransferStatuses.Read)">
							<div class="icon"><svg width="24" style="" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" /> 
									<path fill-rule="evenodd" clip-rule="evenodd" d="M3.00034 10.4147C3 10.569 3 10.7304 3 10.8992V15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15V10.8992C21 10.7304 21 10.569 20.9997 10.4147L19.2929 12.1215C18.7303 12.6841 17.9672 13.0002 17.1716 13.0002H6.82843C6.03278 13.0002 5.26972 12.6841 4.70711 12.1215L3.00034 10.4147ZM3.23713 7.82307L6.12132 10.7073C6.30886 10.8948 6.56321 11.0002 6.82843 11.0002H17.1716C17.4368 11.0002 17.6911 10.8948 17.8787 10.7073L20.7629 7.82307C20.6991 7.63992 20.6182 7.47289 20.5155 7.31487C20.031 6.56931 19.1662 6.18499 17.4368 5.41637L17.4368 5.41636L13.6246 3.72202C12.8245 3.36643 12.4244 3.18863 12 3.18863C11.5756 3.18863 11.1755 3.36643 10.3754 3.72202L6.56317 5.41636C4.83375 6.18499 3.96905 6.56931 3.48452 7.31487C3.38183 7.47289 3.30091 7.63992 3.23713 7.82307Z" fill="#205CDF" />
								</svg>
							</div> 
							{{$t('res_Label_Read')}}
						</v-btn>

						<v-btn id="UnreadIcon" width="auto!important" class=" instructionItem" icon  @click="filterChart(true, TransferStatuses.Unread)">
							<div class="icon"><svg width="24" height="24" viewBox="0 0 24 24" style="" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect width="24" height="24" rx="4" />
									<path fill-rule="evenodd" clip-rule="evenodd" d="M3.0132 9.15129C3 9.69022 3 10.3021 3 11V13C3 15.8284 3 17.2426 3.87868 18.1213C4.75736 19 6.17157 19 9 19H15C17.8284 19 19.2426 19 20.1213 18.1213C21 17.2426 21 15.8284 21 13V11C21 10.3021 21 9.69022 20.9868 9.15129L12.9713 13.6044C12.3672 13.9399 11.6328 13.9399 11.0287 13.6044L3.0132 9.15129ZM3.24297 7.02971C3.32584 7.05052 3.4074 7.08237 3.48564 7.12584L12 11.856L20.5144 7.12584C20.5926 7.08237 20.6742 7.05052 20.757 7.02971C20.6271 6.55619 20.4276 6.18491 20.1213 5.87868C19.2426 5 17.8284 5 15 5H9C6.17157 5 4.75736 5 3.87868 5.87868C3.57245 6.18491 3.37294 6.55619 3.24297 7.02971Z" fill="#205CDF" />
								</svg>
							</div> 
							{{$t('res_Label_Unread')}} 
						</v-btn>
					</div>
		</div>
 
		<v-dialog id="dialogInfo" v-model="document_dialog" width="500">
					<v-card>
						<v-card-title class="pop-up-header">
							<h1>{{$t('res_Label_TrackingInfo')}}</h1>
						</v-card-title>
						<div class="pop-card-items" id="document-dialog-template">  

							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_MenuItems_ReferenceNumber')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ referenceNumberDialog }}</p>
								</div>
							</div>

							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_Label_Sender')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ senderDialog }}</p>
								</div>
							</div>


							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_Label_Recipient')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ recepientDialog }}</p>
								</div>
							</div>

							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_Label_RegisteredBy')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ registeredByDialog }}</p>
								</div>
							</div>

							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_Label_RegisterDate')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ registerDateDialog }}</p>
								</div>
							</div>

							<div class="row m-0">
								<div class="col-4 m-auto">
										<v-label class="text-center tracking-pop-label">{{$t('res_Label_Subject')}}</v-label>
								</div>
								<div class="col-8 m-auto">
										<p class="mb-0 w-100">{{ subjectDialog }}</p>
								</div>
							</div>
						</div>

						<div class="pop-up-footer">
							<v-btn class="primary primary-text-button-footer" text @click="document_dialog = false">
								{{$t('res_ButtonText_Close')}}
							</v-btn>
						</div>
					</v-card>
		</v-dialog>

		 <v-dialog v-model="transfer_dialog" width="500">
					<v-card>
						<v-card-title class="pop-up-header">
							<h1>{{$t('res_Label_TrackingInfo')}}</h1>
						</v-card-title>
						<div class="pop-card-items">
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_From')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{fromDilog}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_To')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{toDialog}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_Purpose')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{purposeDialog}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_TransferDate')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{transferDateDialog}}</p>
							</div> 
							<div class="d-flex justify-space-between pageVisualFlex"> 
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{transferDateDialoglbl}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_DueDate')}}</v-label> 
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{transferDueDateDialog}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex"> 
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{transferDueDateDialoglbl}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_OpenDate')}}</v-label>  
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{ openDateDialog }}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex"> 
								<v-label class="tracking-pop-label">{{$t('res_Label_CloseDate')}}</v-label> 
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{closeDateDialog}}</p>
							</div>
							<div v-if="!isArchivedDialog" class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_instructions')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{instructionsDialog}}</p>
							</div>
							<template v-if="isArchivedDialog">
								<div v-if="instructionsDialog && instructionsDialog !== '--------'" class="d-flex justify-space-between pageVisualFlex">
									<v-label class="tracking-pop-label">{{$t('res_Label_TransferInstruction')}}</v-label>
									<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{instructionsDialog}}</p>
								</div>
								<div class="d-flex justify-space-between pageVisualFlex">
									<v-label class="tracking-pop-label">{{$t('res_Label_ArchiveInstruction')}}</v-label>
									<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{archiveInstructionDialog}}</p>
								</div>
								<div class="d-flex justify-space-between pageVisualFlex">
									<v-label class="tracking-pop-label">{{$t('res_Label_ArchivedBy')}}</v-label>
									<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{archivedByDialog}}</p>
								</div>
								<div class="d-flex justify-space-between pageVisualFlex">
									<v-label class="tracking-pop-label">{{$t('res_Label_ArchivedDate')}}</v-label>
									<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{archivedDateDialog}}</p>
								</div>
							</template>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_ActionTakenBy')}}</v-label>
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{actionTakenByDialog}}</p>
							</div>
							<div class="d-flex justify-space-between pageVisualFlex">
								<v-label class="tracking-pop-label">{{$t('res_Label_OnBehalfOf')}}</v-label>  
								<p class="tracking-pop-info bg-gray rounded-1 p-2 w-100">{{onBehalfOfDialog}}</p>
							</div>
						</div>
						<div class="pop-up-footer">
							<v-btn class="primary primary-text-button-footer" text @click="transfer_dialog = false">
									{{$t('res_ButtonText_Close')}}
							</v-btn>
						</div>
					</v-card>
		 </v-dialog> 

	</div> 
</template>
 
<script>
    import axios from 'axios'
	import { OrgChart } from "d3-org-chart"
    import constants from '@/assets/js/constants' 

	export default {
		name: "Tracking",
		props: {
			documentId: 0,
			closeDialogFunc: Function, 
		},
		data() {
			return {
				searchValue: '',
				chartData: null,
				ShowChart: false, 
				chart: null,
				compact: 0,
				index: 0,
				document_dialog: false,
				transfer_dialog: false,
				isInProgress:false,
                isCompleted:false,
                isOverdue:false,
                isCC:false,
                isRead:false,
                isUnRead:false,
				referenceNumberDialog: '',
				senderDialog:'',
				recepientDialog:'',
				registeredByDialog:'',
				registerDateDialog:'',
				subjectDialog:'',
				fromDilog:'',
                toDialog:'',
                purposeDialog:'',
                transferDateDialog:'',
                transferDueDateDialog:'',
                transferDueDateDialoglbl: `${this.$t('res_Label_Delayed_by')} 0 ${this.$t('res_Label_Day_Unit')}`,
				transferDateDialoglbl:`${this.$t('res_Label_Active_For')} 0 ${this.$t('res_Label_Day_Unit')}`,
                openDateDialog :'',
                closeDateDialog:'',
                instructionsDialog:'',
                actionTakenByDialog:'',
                onBehalfOfDialog:'',
                isArchivedDialog:false,
                archiveInstructionDialog:'',
                archivedByDialog:'',
                archivedDateDialog:'',
				nodesCount:0,
			    TransferStatuses: {
					InProgress: 1,
					Completed: 2,
					Overdue: 3,
					CCed: 4,
					Read: 5,
					Unread: 6,
				},
			};
		},
		mounted() 
		{  
			this.BuildChart();
		}, 
		methods: { 
			stringifyDateDifference(difference, inDays = false) {   
				let years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365.25));
				let months = Math.floor((difference % (1000 * 60 * 60 * 24 * 365.25)) / (1000 * 60 * 60 * 24 * 30.4375));
				let days = Math.floor((difference % (1000 * 60 * 60 * 24 * 30.4375)) / (1000 * 60 * 60 * 24));
				let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));  
				if(inDays == false)
				{ 
					let parts = [];  
					if(years > 0 )
					{
						parts.push(years + ` ${this.$t('res_Label_Year_Unit')}`);
						parts.push(months + ` ${this.$t('res_Label_Month_Unit')}`);
						parts.push(days +  ` ${this.$t('res_Label_Day_Unit')}`);
					}
					else if (months > 0)
					{ 
						parts.push(months + ` ${this.$t('res_Label_Month_Unit')}`);
						parts.push(days +  ` ${this.$t('res_Label_Day_Unit')}`); 
						parts.push(hours + ` ${this.$t('res_Label_Hour_Unit')}`); 
					}
					else if (days > 0 || hours > 0 || minutes > 0)
					{ 
						parts.push(days +  ` ${this.$t('res_Label_Day_Unit')}`); 
						parts.push(hours + ` ${this.$t('res_Label_Hour_Unit')}`); 
						parts.push(minutes +  ` ${this.$t('res_Label_Minute_Unit')}`);  
					}
					else
					{  
						parts.push(0 + ` ${this.$t('res_Label_Day_Unit')}`); 
					}  
					return parts.join("  "); 
				}
				else
				{ 
					days = difference / (1000 * 3600 * 24);
					let res = `0 ${this.$t('res_Label_Day_Unit')}`;  
					if (days > 0)
					{
						res = parseInt(days) + ` ${this.$t('res_Label_Day_Unit')}`; 
					}  
					return res;
				} 
			},
			closeDialog() { 
				this.closeDialogFunc();
		    },   
			changeCompactLevel() {
				this.chart
					.compact(!!(this.compact++ % 2))
					.render();  
			},
			fitChart()
			{
				this.centerChart(); 
			},
			swap(direction) { 
				document.getElementById(`${direction}Icon`).classList.add('custom-icon-Active');
				document.getElementById(`${(direction == 'horizontal' ? 'top' : 'horizontal')}Icon`).classList.remove('custom-icon-Active');  
				if(direction == 'horizontal') { direction = localStorage.getItem('lang') == 'en' ? 'left' : 'right' }
				this.chart.layout(direction).render(); 
				this.centerChart();  
			}, 
			zoomIn() { 
				this.chart.render().zoomIn();  
			},
			zoomOut() {
				this.chart.render().zoomOut();   
			},   
			centerChart(init = false)
			{   
				if(init)
				{  
					setTimeout(function() {  
						document.getElementById('swapTopBtn').click();
					}, 100 );
				}
				else
				{
					this.chart.fit();
				}
				
			},
            filterChart(byStatus = false , TransferStatuseId) {   
            const value = this.searchValue; 
            this.chart.clearHighlighting(); 
            const data = this.chart.data();    
			if (data) 
			        { 
						if(byStatus) //filter by status has been commented ,,(it could be used later on)
						{	 
							return;
							this.searchValue = '';
							data.forEach((d) => 	{  
								if (
								(TransferStatuseId == this.TransferStatuses.InProgress && d.transferObject.isInProgress)
								|| (TransferStatuseId == this.TransferStatuses.Completed && d.transferObject.isCompleted)
								|| (TransferStatuseId == this.TransferStatuses.Overdue && d.transferObject.isOverdue)
								|| (TransferStatuseId == this.TransferStatuses.CCed && d.transferObject.isCCed)
								|| (TransferStatuseId == this.TransferStatuses.Read && d.transferObject.isRead)
								|| (TransferStatuseId == this.TransferStatuses.Unread && d.transferObject.isUnread)
									)
								{
									d._highlighted = true;
									d._expanded = true;
								}
								else
								{
									d._expanded = true;
									d._highlighted = false;
								}
							});
						}
						else
						{ 
							data.forEach((d) => 	{ 
								if (value && 
								
								( 
									(d.transferObject?.transferToUser?.toLowerCase()?.includes(value.toLowerCase()) || d.transferObject?.transferToUserAr?.includes(value.toLowerCase())) ||
									(d.transferObject?.purposeName?.toLowerCase()?.includes(value.toLowerCase()) || d.transferObject?.purposeNameAr?.includes(value.toLowerCase())) || 
									(d.transferObject?.receivingEntity?.toLowerCase()?.includes(value.toLowerCase()) || d.transferObject?.receivingEntityAr?.includes(value.toLowerCase())) 
								)
								
								) 
								{ 
									d._highlighted = true;
									d._expanded = true;
								}
								else
								{
									d._expanded = true;
									d._highlighted = false;
								}
							});
					    } 
					}	
			this.chart.data(data).render(); 
			this.centerChart();  
  			},
			viewTransferIcons(transfer , cardTemplate)
			{
				if(transfer.isInProgress)
				{  
					cardTemplate = 	cardTemplate.replaceAll(`InProgressIconClass hiddenClass`, `InProgressIconClass`); 
				} 
				if(transfer.isCompleted && !transfer.isCompletedWithDelay) 
				{
					cardTemplate = 	cardTemplate.replaceAll(`CompletedIconClass hiddenClass`, `CompletedIconClass`);  
				} 
				if(transfer.isOverdue  && !(transfer.isCompletedWithDelay || transfer.isCompleted))
				{ 
					cardTemplate = 	cardTemplate.replaceAll(`OverdueIconClass hiddenClass`, `OverdueIconClass`);  
				} 
				if(transfer.isCCed) 
				{ 
					cardTemplate = 	cardTemplate.replaceAll(`CCedIconClass hiddenClass`, `CCedIconClass`);    
				} 
				if(transfer.isRead) 
				{  
					cardTemplate = 	cardTemplate.replaceAll(`ReadIconClass hiddenClass`, `ReadIconClass`);   
				} 
				if(transfer.isUnread) 
				{
					cardTemplate = 	cardTemplate.replaceAll(`UnreadIconClass hiddenClass`, `UnreadIconClass`);  
				}  
				if(transfer.isSigned)  
				{
					cardTemplate = 	cardTemplate.replaceAll(`SignedIconClass hiddenClass`, `SignedIconClass`);  
				}  
				if(transfer.isCompletedWithDelay)  
				{
					cardTemplate = 	cardTemplate.replaceAll(`CompletedWithDelayIconClass hiddenClass`, `CompletedWithDelayIconClass`);  
				}  

				return cardTemplate;
			},
			BuildChart()
			{  
				// this.chart = new OrgChart();
				if (!this.chart) {this.chart = new OrgChart();} 
				
				axios.get(`${constants.baseApiUrl}Transfer/GetTrackingDataWithSign?documentId=${this.documentId}`)
					.then((response) => 
					{    
						this.chartData = response.data.records;
						this.nodesCount = this.chartData.length;
						this.chart.container(this.$refs.svgElementContainer)
							.data(this.chartData)
							.nodeHeight(() => { return 185 })
							.nodeWidth((d) => { return 320 })
							.onNodeClick((data) => {
								const lang = localStorage.getItem('lang');
								const searchObject= this.chartData.find((TrackingData) => TrackingData.id==data);

								if (data == -1)
								{  
									this.document_dialog = true; 
									let referenceNumber=searchObject.transferObject.referenceNumber;
									let sendingEntity=lang == 'en' ? searchObject.transferObject.sendingEntity : searchObject.transferObject.sendingEntityAr;
									let receivingEntity=lang == 'en' ? searchObject.transferObject.receivingEntity : searchObject.transferObject.receivingEntityAr;
									let registeredByUser=lang == 'en' ? searchObject.transferObject.registeredByUser : searchObject.transferObject.registeredByUserAr;
									let modifiedDate=searchObject.transferObject.modifiedDate;
									let subject=searchObject.transferObject.subject; 
									
									this.referenceNumberDialog=referenceNumber;
									this.senderDialog=sendingEntity;
									this.recepientDialog=receivingEntity;
									this.registeredByDialog=registeredByUser;
									this.registerDateDialog=modifiedDate.replaceAll('T',' ').split('.')[0];
									this.subjectDialog=subject; 
								}
								else 
								{ 
									this.transfer_dialog = true; 
									this.fromDilog=lang == 'en' ? searchObject.transferObject.transferFromStructureName+'/'+searchObject.transferObject.transferFromUser :
									searchObject.transferObject.transferFromStructureNameAr+'/'+searchObject.transferObject.transferFromUserAr;
									this.toDialog= lang == 'en' ? searchObject.transferObject.transferToStructureName+'/'+searchObject.transferObject.transferToUser :
									searchObject.transferObject.transferToStructureNameAr +'/'+searchObject.transferObject.transferToUserAr;
									this.purposeDialog= lang == 'en' ? searchObject.transferObject.purposeName : searchObject.transferObject.purposeNameAr; 
 
									let TransferDueDate = searchObject.transferObject.transferDueDate;
									let CloseDate = searchObject.transferObject.transferCloseDate;
									let TransferDate = searchObject.transferObject.transferDate;
 
									// Transfer Date Delay Label 
									this.transferDateDialog=searchObject.transferObject.transferDate.replaceAll('T',' ').split('.')[0];
									  if(CloseDate !=  null && CloseDate != "null" && CloseDate != '' )
										{
											if(new Date(CloseDate) > new Date(TransferDate))
											{
												this.transferDateDialoglbl = `${this.$t('res_Label_Active_For')} ${this.stringifyDateDifference(new Date(CloseDate) - new Date(TransferDate))}`; 
											}
										}
										else if (TransferDate !=  null && TransferDate != "null" && TransferDate != '' )
										{
											if(new Date(TransferDate) < new Date())
											{
												this.transferDateDialoglbl = `${this.$t('res_Label_Active_For')} ${this.stringifyDateDifference(new Date() - new Date(TransferDate))}`;  
											} 
										}	
											  
									if(searchObject.transferObject.transferDueDate){
										this.transferDueDateDialog=searchObject.transferObject.transferDueDate.replaceAll('T',' ').split('.')[0];
										
										// Transfer Due Date Delay Label 
										if(CloseDate !=  null && CloseDate != "null" && CloseDate != '' )
											{
												if(new Date(CloseDate) > new Date(TransferDueDate))
												{
													this.transferDueDateDialoglbl =  `${this.$t('res_Label_Delayed_by')} ${this.stringifyDateDifference(new Date(CloseDate) - new Date(TransferDueDate),true)}`;
												}
											}
											else if (TransferDueDate !=  null && TransferDueDate != "null" && TransferDueDate != '' )
											{
												if(new Date(TransferDueDate) < new Date())
												{ 
													this.transferDueDateDialoglbl =  `${this.$t('res_Label_Delayed_by')} ${this.stringifyDateDifference(new Date() - new Date(TransferDueDate),true)}`;
												} 
											}
									}
									else
									{
										this.transferDueDateDialog='--------';
									}

									// transferDateDialoglbl

									if(searchObject.transferObject.transferOpenedDate)
									{
										this.openDateDialog=searchObject.transferObject.transferOpenedDate.replaceAll('T',' ').split('.')[0];
									}
									else
									{
										this.openDateDialog='--------';
									}

									if(searchObject.transferObject.transferCloseDate){
										this.closeDateDialog=searchObject.transferObject.transferCloseDate.replaceAll('T',' ').split('.')[0];
									}
									else
									{
										this.closeDateDialog='--------';
									}
									
									if(searchObject.transferObject.transferNote)
									{
										this.instructionsDialog=searchObject.transferObject.transferNote;
									}
									else
									{
										this.instructionsDialog='--------';
									}

									this.isArchivedDialog = searchObject.transferObject.isArchived === true;
									this.archiveInstructionDialog = searchObject.transferObject.archiveInstruction || '--------';
									this.archivedByDialog = (lang == 'en'
										? searchObject.transferObject.archivedByUser
										: searchObject.transferObject.archivedByUserAr) || '--------';
									this.archivedDateDialog = searchObject.transferObject.archivedDate
										? searchObject.transferObject.archivedDate.replaceAll('T',' ').split('.')[0]
										: '--------';

									this.actionTakenByDialog=searchObject.transferObject.actionTakenBy;
									
									if(searchObject.transferObject.onBehalfOf)
									{
										this.onBehalfOfDialog= lang == 'en' ? searchObject.transferObject.onBehalfOf : searchObject.transferObject.onBehalfOfAr;
									}
									else
									{
										this.onBehalfOfDialog='--------';
									}  
								}
								
							})
							.childrenMargin((d) => 90)
							.compactMarginBetween((d) => 65)
							.compactMarginPair((d) => 100)
							.neightbourMargin((a, b) => 50)
							.siblingsMargin((d) => 100)
							.buttonContent(({ node, state }) => {
								return `<div class="expand-btn"><span>${
									node.children
										? `<i class="fas fa-minus"></i>`
										: `<i class="fas fa-plus"></i>`
								}</span></div>`;
							})
							.nodeContent(function (d, i, arr, state) 
							{	  
								const lang = localStorage.getItem('lang'); 

								if (d.data.id == -1)
								{
									let sendingEntityEn = d.data.transferObject.sendingEntity
									let sendingEntityAr = d.data.transferObject.sendingEntityAr
									let registeredByUserEn = d.data.transferObject.registeredByUser
									let registeredByUserAr = d.data.transferObject.registeredByUserAr
									let referenceNumber = d.data.transferObject.referenceNumber
									
									if(sendingEntityEn.length > 30){
										sendingEntityEn = sendingEntityEn.substring(0,27) + "..."
									}
									if(registeredByUserEn.length > 30){
										registeredByUserEn = registeredByUserEn.substring(0,27) + "..."
									}

									let cardTemplate = document.getElementById("root-card-template").innerHTML;
									cardTemplate = cardTemplate.replaceAll('_SenderEntity_', lang == 'en' ? sendingEntityEn : sendingEntityAr);
									cardTemplate = cardTemplate.replaceAll('_RegisteredByUser_', lang == 'en' ? registeredByUserEn : registeredByUserAr);
									cardTemplate = cardTemplate.replaceAll('_ReferenceNumber_', referenceNumber); 
									cardTemplate = this.viewTransferIcons(d.data.transferObject , cardTemplate);
									
									return cardTemplate;
								}
								else
								{
									let transferToStructureName= lang=='en' ? d.data.transferObject.transferToStructureName : d.data.transferObject.transferToStructureNameAr;
									if(transferToStructureName.length > 30){
										transferToStructureName = transferToStructureName.substring(0,27) + "..."
									}
									let transferToUser=lang=='en' ?  d.data.transferObject.transferToUser : d.data.transferObject.transferToUserAr;
									if(transferToUser.length > 30){
										transferToUser = transferToUser.substring(0,27) + "..."
									}
									let purposeName= lang == 'en' ? d.data.transferObject.purposeName : d.data.transferObject.purposeNameAr;
								
									let transferDate=d.data.transferObject.transferDate
									let transferOpenedDate=d.data.transferObject.transferOpenedDate

									let cardTemplate = document.getElementById("card-template").innerHTML;   
										cardTemplate = this.viewTransferIcons(d.data.transferObject , cardTemplate); 
										
									if(d.data.transferObject.isSecret == true)
									{
										cardTemplate = cardTemplate.replaceAll('_TransferId_','');
										cardTemplate = cardTemplate.replaceAll('_TransferToStructureName_', '');
										cardTemplate = cardTemplate.replaceAll('_TransferToUser_','');
										cardTemplate = cardTemplate.replaceAll('_PurposeName_', this.$t('res_Label_Confidential_Data'));
									}
									else
									{
										cardTemplate = cardTemplate.replaceAll('_TransferId_', d.data.transferObject.transferId);
										cardTemplate = cardTemplate.replaceAll('_TransferToStructureName_', transferToStructureName);
										cardTemplate = cardTemplate.replaceAll('_TransferToUser_', transferToUser);
										cardTemplate = cardTemplate.replaceAll('_PurposeName_', purposeName);
									}  
									
									cardTemplate = cardTemplate.replaceAll('_TransferDate_', transferDate.replaceAll('T',' ').split('.')[0]);

									if(transferOpenedDate != null)
									{
										cardTemplate = cardTemplate.replaceAll('_TransferOpenedDate_', transferOpenedDate.replaceAll('T',' ').split('.')[0]);
									}
									else
									{
										cardTemplate = cardTemplate.replaceAll('_TransferOpenedDate_', '');
									}

									if(d.childern != null)
									{
										cardTemplate = cardTemplate.replaceAll('${ d.data.transferObject.transferToUser }', d.children[i].data.transferObject.subject);
									}     

									return cardTemplate;
								}
							}.bind(this)) 
							.render() 
							.expandAll();  
						this.chart.compact(!!(this.compact++ % 2)).render();     
						this.ShowChart = true;    
						this.centerChart(true);
					}); 
  		  
			}
		},  
		watch: {
			documentId() {
				
				if (this.documentId > 0) {
					this.BuildChart(); 
				}
			},
		},
	};
</script>
 
<style scoped>
		.IconFit
		{
			color:#667593
		}

		.IconFit:hover
		{
			color:#5783E7
		}

	.hiddenClass
	{
		display: none !important;
	}
	
	.icon {
		width: 26px;
		height: 26px;
		background: #f5f7f9; 
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.icon svg {
		max-width: 17px;
		max-height: 17px;
	}
	.icon > span {
		font-weight: bold;
		font-size: 13px;
		text-indent: unset;
		color: #205cdf;
	}
	.tracking-footer .icon > span {
		font-size: 15px;
	} 


	.tracking-footer button {
		cursor: default !important;
	} 

	.pop-card-items
	{  
	    max-height: 500px;
		overflow-y: auto !important;
		overflow-x: hidden !important;
	}
</style>
 
<style>
 

 .tracker-tooltip {
  position: relative;
  display: inline-block;
}
 
.tracker-tooltiptext {
  visibility: hidden;
  width: 100px;
  font-size:10px;
  background-color: black;
  color: #fff !important;
  font-weight: 700;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  position: absolute;
  z-index: 1;
}

.tracker-tooltip .tracker-tooltiptext {
  bottom: 100%;
  left: 50%;
  margin-left: -48px;  
}


.tracker-tooltip:hover .tracker-tooltiptext {
  visibility: visible;
}

.tracker-tooltip .tracker-tooltiptext {
  transition: opacity 0.3s;
  opacity: 0;
}

.tracker-tooltip:hover .tracker-tooltiptext {
  visibility: visible;
  opacity: 1;
}

  
.CardIconBtntracker-tooltip { 
	font-family: var(--main-font-family);
	position: absolute;
	top: -25px;
	left: -2px;
} 

.body-left-icons h3{ 
	font-family: var(--main-font-family) !important;
}
.body-left-icons p{ 
	font-family: var(--main-font-family)  !important;
} 

.template_card h3{ 
	font-family: var(--main-font-family) !important;
}
.template_card p{ 
	font-family: var(--main-font-family)  !important;
}
  
.tracker-tooltip-hidden
{
	display: none !important;
}
.custom-icon-Active {
      filter: brightness(0) saturate(100%) invert(32%) sepia(80%) saturate(1404%) hue-rotate(204deg) brightness(86%) contrast(109%);
}

.TrackerBtn button{
	cursor: pointer !important;  
}

.instructionItem span{ 
	color: black !important;
	padding: 1.5rem;
}
 
 .tracking-footer button {
  transition: opacity 0.5s ease-in-out; 
  padding: 0 0.5rem;
}
 
.CardIconBtnbackground
{
	background-color: #205CDF;  
}

.CardIconBtnbackground span
{
	 color: #ffffff !important;  
}


.CardIconBtnbackground span div
{
	background-color: #205CDF  !important;    
}

.CardIconBtnbackground span div svg path
{
	fill: #ffffff  !important;    
}


.instructionItem
{ 
	box-shadow: none !important;
	font-size: 11px !important;
	cursor: pointer !important;
}

.instructionItem:hover
{ 
	box-shadow: none !important; 
}


#ChartContainer svg {
	width:  100% !important;
}
</style> 
